import { useMutation, useQuery } from "@apollo/client";
import { useState } from "react";
import { useHistory } from "react-router-dom";
import { ADD_STAT_MUTATION, END_GAME_MUTATION, GET_INPROGRESS_GAME, getAllPlayers } from "../../api/queries";
import SelectPlayerModal from "../../components/SelectPlayerModal";
import useModal from "../../hooks/useModal";
import "./Game.scss";

const ActionType = {
    THREEPTER: 'THREEPTER',
    TWOPTER: 'TWOPTER',
    AST: 'AST',
    RBD: 'RBD',
    FOUL: 'FOUL'
}

const TeamType = {
    HOME: 'HOME',
    AWAY: 'AWAY'
}

function Game() {
    const history = useHistory();

    const { isShowing: awayModalShowing, toggle: toggleAwayModal } = useModal();

    const { isShowing: homeModalShowing, toggle: toggleHomeModal } = useModal();

    const [statSelected, setStatSelected] = useState('');

    const { loading, error, data } = useQuery(GET_INPROGRESS_GAME, {
        variables: {
            tenant: 1
        }
    });

    const [addStat, {}] = useMutation(ADD_STAT_MUTATION, {
       refetchQueries: [
        {
          query: GET_INPROGRESS_GAME,
          variables: { tenant: 1 },
        },
      ]
    });

    const [endGame] = useMutation(END_GAME_MUTATION, {
        refetchQueries: [
            {
              query: getAllPlayers,
              variables: { tenant: 1 }
            }
        ]});

    if (loading) return <p>Loading...</p>

    if (!data.inProgressGame || error) {
        history.push("/select-players");
        return <p>Redirecting...</p>
    }

    const playerSelected = (player, team) => {
        addStat({
            variables: {
                tenant: 1,
                action: statSelected,
                team: team,
                playerId: player.id
            }
        })
    }

    const statClicked = (stat, toggle) => {
        setStatSelected(stat);
        toggle();
    }

    const completeGame = () => {
        endGame({
            variables: {
                tenant: 1
            }
        })
        history.push("/players")
    }

    const game = data.inProgressGame;

    return (
        <div className="game-container">
            <div className="header-container">
                <h3>Game</h3>
                <p>{game.home.points} - {game.away.points}</p>
            </div>
            <div className="score-containers">
                <div className="score-container left">
                    <h3 className="score-title">Home</h3>
                    <button className="stat-button" onClick={() => statClicked(ActionType.THREEPTER, toggleHomeModal)}>+3PTS</button>
                    <button className="stat-button" onClick={() => statClicked(ActionType.TWOPTER, toggleHomeModal)}>+2PTS</button>
                    <button className="stat-button" onClick={() => statClicked(ActionType.AST, toggleHomeModal)}>+1AST</button>
                    <button className="stat-button" onClick={() => statClicked(ActionType.RBD, toggleHomeModal)}>+1RBD</button>    
                    <SelectPlayerModal players={game.home.players} isShowing={homeModalShowing} hide={toggleHomeModal} onComplete={(player) => playerSelected(player, TeamType.HOME)}></SelectPlayerModal>
                </div>
                <div className="score-container right">
                    <h3 className="score-title">Away</h3>
                    <button className="stat-button" onClick={() => statClicked(ActionType.THREEPTER, toggleAwayModal)}>+3PTS</button>
                    <button className="stat-button" onClick={() => statClicked(ActionType.TWOPTER, toggleAwayModal)}>+2PTS</button>
                    <button className="stat-button" onClick={() => statClicked(ActionType.AST, toggleAwayModal)}>+1AST</button>
                    <button className="stat-button" onClick={() => statClicked(ActionType.RBD, toggleAwayModal)}>+1RBD</button>     
                    <SelectPlayerModal players={game.away.players} isShowing={awayModalShowing} hide={toggleAwayModal} onComplete={(player) => playerSelected(player, TeamType.AWAY)}></SelectPlayerModal>
                </div>
            </div>
            <button onClick={() => completeGame()}>End Game</button>
        </div>
    )
}

export default Game;